import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { authAPI } from '../utils/api'
import Header from '../components/Header'
import Toast from '../components/Toast'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faKey, faLock, faShieldHalved, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'

function ChangePassword({ user, onLogout }) {
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match')
      return
    }

    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters')
      return
    }

    setLoading(true)
    try {
      await authAPI.changePassword(oldPassword, newPassword)
      setSuccess('Password changed successfully')
      setTimeout(() => navigate('/dashboard'), 1200)
    } catch (err) {
      setError(err.response?.data?.error || 'Password change failed')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <Header user={user} onLogout={onLogout} />
      <div className="min-h-[calc(100vh-72px)] bg-slate-50 px-4 py-8 flex items-center justify-center">
        <div className="w-full max-w-xl space-y-6">
          <div className="rounded-3xl bg-gradient-to-br from-slate-950 via-slate-900 to-indigo-950 text-white p-6 md:p-8 shadow-2xl">
            <div className="flex items-start gap-4">
              <div className="h-12 w-12 rounded-2xl bg-white/10 flex items-center justify-center shrink-0">
                <FontAwesomeIcon icon={faKey} />
              </div>
              <div>
                <h1 className="text-3xl font-black">Change Password</h1>
                <p className="text-slate-300 mt-2">Set a new password before continuing to the dashboard.</p>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="mb-4 flex items-start gap-3 rounded-2xl bg-amber-50 border border-amber-100 p-4">
              <FontAwesomeIcon icon={faTriangleExclamation} className="text-amber-600 mt-1" />
              <p className="text-sm text-slate-700">
                Use the password from your first login as the old password. After changing it once, use the new password next time.
              </p>
            </div>

            {error && <Toast message={error} type="error" onClose={() => setError('')} />}
            {success && <Toast message={success} type="success" onClose={() => setSuccess('')} />}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Old Password</label>
                <input
                  type="password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  className="input"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="input"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Confirm Password</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="input"
                  required
                />
              </div>

              <button type="submit" disabled={loading} className="btn btn-primary w-full inline-flex items-center justify-center gap-2">
                <FontAwesomeIcon icon={faShieldHalved} />
                {loading ? 'Saving...' : 'Save new password'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChangePassword